import { Form, Input, Typography } from 'antd';

import { useClientImportantFields } from '@app/components/RecordModal/components/RecordDetails/components/ClientImportantFields/hooks';
import { PF } from '@app/components/RecordModal/components/RecordDetails/data/constants';

import type { FC } from 'react';

const FIELD_VALUE_MAX_LENGTH = 5000;
const { Text } = Typography;
const { Item } = Form;
const { TextArea } = Input;

interface ClientImportantFieldsProps {
  clientId: number | null;
  isDisabled: boolean;
}

/**
 * Важные дополнительные поля клиента на главном экране записи. Рендерятся
 * строками формы (как «Имя»/«Фамилия») внутри блока `__main-fields`, сразу
 * после «Фамилии» и до «Типа записи». Значения редактируются и сохраняются
 * вместе с записью по кнопке «Сохранить» (см. useRecordDetails).
 */
export const ClientImportantFields: FC<ClientImportantFieldsProps> = ({
  clientId,
  isDisabled,
}) => {
  const { importantFields } = useClientImportantFields({ clientId });

  if (!importantFields.length) return null;

  return (
    <>
      {importantFields.map(({ FieldId, FieldName }) => (
        <div
          key={FieldId}
          className={`${PF}__main-fields-item ${PF}__main-fields-item--textarea`}
        >
          <Text
            className={`${PF}__main-fields-label`}
            data-testid={`record-important-field-label-${FieldId}`}
          >
            {FieldName}
          </Text>
          <Item
            name={['ClientFieldValues', String(FieldId)]}
            className={`${PF}__main-fields-input`}
          >
            <TextArea
              autoSize={{ minRows: 1, maxRows: 4 }}
              size="large"
              maxLength={FIELD_VALUE_MAX_LENGTH}
              disabled={isDisabled}
              data-testid={`record-important-field-value-${FieldId}`}
            />
          </Item>
        </div>
      ))}
    </>
  );
};
